<template>
  <div class="main-content">
    <div class="wrap-content container" id="container">
      <!-- start: PAGE TITLE -->
      <section id="page-title" style="background-color: #d1d1d1;">
        <div class="row">
          <div class="col-sm-10">
            <h1 class="mainTitle">All Medical Condtions</h1>
          </div>
          <div class="col-sm-2">
            <router-link v-if="hasPermission('medical-condition create')" style="margin-right: 10px"
              class="btn btn-primary" :to="{ name: 'create-conditionMedical' }">create</router-link>
            <router-link v-if="hasPermission('medical-condition getSoftDeleted')" class="btn btn-success"
              :to="{ name: 'deleted-conditionMedicals' }">Deleted
              Conditions</router-link>
          </div>
        </div>
      </section>
      <!-- end: PAGE TITLE -->
      <!-- start: DYNAMIC TABLE -->
      <div class="container-fluid container-fullw bg-white">
        <div class="row">
          <div class="col-md-12">
            <div v-if="conditionMedicals.length > 0">

              <MyTable :columns="columns" :actions="true">
                <tr v-for="(conditionMedical, index) in filteredConditionMedicals" :key="index">
                  <th scope="row">{{ conditionMedical.id }}</th>
                  <td>{{ conditionMedical.name_ar }}</td>
                  <td>{{ conditionMedical.name_en }}</td>
                  <td>
                    <button class="me-2 btn btn-danger" v-if="hasPermission('medical-condition delete')"
                      @click="deleteConditionMedical(conditionMedical.id)">
                      Delete
                    </button>
                    <router-link class="btn btn-primary spacing" v-if="hasPermission('medical-condition update')"
                      :to="{ name: 'edit-conditionMedical', params: { id: conditionMedical.id } }">
                      Edit
                    </router-link>
                  </td>
                </tr>
              </MyTable>
            </div>
            <div v-else class="alert alert-info">
              No Medical Conditions found.
            </div>
          </div>
        </div>
      </div>
      <!-- end: DYNAMIC TABLE -->
    </div>
  </div>
</template>

<script>
import axios from "../../Axios";
import { store } from "../../Store";
import $ from 'jquery'; // Import jQuery
import MyTable from "../MyTable//MyTable.vue"; // Import your MyTable component
export default {
  name: "AllConditionMedicals",

  components: {
    MyTable,
    // Paginate,
  },
  data() {
    return {
      conditionMedicals: [],
      meta: {},
      searchTerm: "",
      dataTable: [], // Store DataTable instance
      columns: [
        { label: '#', key: 'id' },
        { label: 'Name Arabic', key: 'name_ar' },
        { label: 'Name English', key: 'name_en' },
      ],
    };
  },

  async created() {
    this.fetchConditionMedicals();
  },

  computed: {
    hasPermission() {
      return (permission) => store.hasPermission(permission);
    },
    filteredConditionMedicals() {
      if (!this.searchTerm) {
        return this.conditionMedicals;
      }
      const term = this.searchTerm.toLowerCase();
      return this.conditionMedicals.filter(
        (conditionMedical) =>
          conditionMedical.name.toLowerCase().includes(term) ||
          conditionMedical.postal_code.toLowerCase().includes(term)
      );
    },
  },

  methods: {
    // fetch conditionMedicals
    async fetchConditionMedicals() {
      try {
        const response = await axios.get(
          `/admin/admin/condition-medical/all`
        );
        this.conditionMedicals = response.data.data;
        this.meta = response.data.meta;
        this.$nextTick(() => {
          this.initializeDataTable(); // Initialize DataTable after fetching users
        });
      } catch (error) {
        console.error("Error fetching conditionMedicals:", error);
      }
    },
    initializeDataTable() {
      this.$nextTick(() => {
        // Ensure the DataTable is initialized only after the DOM is updated
        $('.sample_1').DataTable(); // Initialize DataTable
      });
    },
    deleteConditionMedical(id) {
      console.log("delete conditionMedical id: ", id);
      axios
        .delete(`/admin/admin/condition-medical/delete?id=${id}`)
        .then((response) => {
          console.log(response.data);
          this.fetchConditionMedicals();
        })
        .catch((error) => {
          console.error(error);
        });
    },
  },

};
</script>
<style scoped>
.table {
  margin-top: 10px;
}

.spacing {
  margin-left: 10px !important;
}
</style>
